import Axios from "@app/api/axios";

import { GENERATE_OTP_API } from "@utils/constant";

const generateOtpService = payload =>
  Axios.post(`${GENERATE_OTP_API}`, payload);

export default generateOtpService;
